import WithSideNavigations from '@/layouts/WithSideNavigations.vue';
import ClientsSidebar from '@/views/Dashboard/Clients/ClientsSidebar.vue';
import FilterToggler from '@/components/Filters/FilterToggler.vue';
import ClientsList from '@/views/Dashboard/Clients/Components/ClientsList.vue';
import SlotTabs from '@/components/Tabs/SlotTabs.vue';
import { defineComponent, ref, computed, } from '@vue/composition-api/dist/vue-composition-api';
const CLIENT_TABS = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
};
export default defineComponent({
    name: 'Clients',
    components: {
        WithSideNavigations,
        ClientsSidebar,
        FilterToggler,
        ClientsList,
        SlotTabs,
    },
    setup(props, ctx) {
        const activeTab = ref(CLIENT_TABS.ACTIVE);
        const tabs = computed(() => ({
            [CLIENT_TABS.ACTIVE]: {
                name: CLIENT_TABS.ACTIVE,
                label: ctx.root.$t('clients-view.active'),
            },
            [CLIENT_TABS.ARCHIVED]: {
                name: CLIENT_TABS.ARCHIVED,
                label: ctx.root.$t('clients-view.archived'),
            },
        }));
        const selectTab = (tab) => {
            activeTab.value = tab.name;
        };
        return {
            activeTab,
            tabs,
            selectTab,
            CLIENT_TABS,
        };
    },
});
